export interface ITableProcessItem {
    identifier: string;
    before: boolean;
    after: boolean;
    show: boolean;
}

export class TableProcessItem implements ITableProcessItem {
    public identifier: string;
    public before: boolean;
    public after: boolean;
    public show: boolean;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ITableProcessItem);
    constructor(obj?: any) {
        this.identifier = obj && obj.identifier || '';
        this.before = obj && obj.before || false;
        this.after = obj && obj.after || false;
        this.show = obj && obj.show || false;
    }
}
